import IngredientCount from "@/components/single/ingredient/IngredientCount.vue";
export default {
  components: {
    IngredientCount
  },
  methods: {
    doShortcode(content) {
      const regex = /\[([^[\]]*)\]/g;
      const test = content.replace(regex, match => {
        match = match.slice(1, -1); // 'remove Bracket []'
        let number = match;
        const regexVal = /[0-9.]*/;
        let unit = match.replace(regexVal, matchVal => {
          number = matchVal;
          return "";
        });
        if (unit == "") {
          unit = "false";
        } else {
          unit = `'${unit}'`;
        }
        let props = "";
        props += `:counter="${this.counter}" `;
        props += `:nbPerson="${this.nbPerson}" `;
        props += `:quantity="${number}" `;
        props += `:unit="${unit}" `;
        return `<IngredientCount ${props}/>`;
      });
      return {
        components: { IngredientCount },
        template: "<span>" + test + "</span>"
      };
    }
  }
};
